import { PSP } from "../../constants";

export default (payment, t) => {
  if (payment.payment_provider === PSP.paypal || payment.payment_provider === PSP.braintree) {
    return t("Riders.Receipt.PaymentProvider.Paypal");
  }
  if (payment.payment_method) {
    return payment.cardInfo;
  }
  return t(`Riders.Receipt.${payment?.label}`);
  };
